import React, { useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import {
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { Link } from "react-router-dom";
import { enqueueSnackbar } from "notistack";

export default function Registerform() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    enqueueSnackbar("Registration Successful", { variant: "success" });
  };

  return (
    <div className="container register_page">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 register-box mt-5">
          <h2 className="register-title">Register</h2>
          <p className="register-subtitle">
            Creating an account requires providing your details to register and
            access platform features and services.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                required
                type="text"
                placeholder="First Name"
                className="input-field"
              />
              <input
                required
                type="text"
                placeholder="Last Name"
                className="input-field"
              />
            </div>
            <div className="input-group">
              <input
                required
                type="email"
                placeholder="Email"
                className="input-field"
              />
              <div className="position-relative password-field">
                <input
                  required
                  type={passwordVisible ? "text" : "password"}
                  placeholder="Password"
                  className="input-field"
                />
                <span
                  className="eye-icon position-absolute"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? (
                    <VisibilityOutlinedIcon />
                  ) : (
                    <VisibilityOffOutlinedIcon />
                  )}
                </span>
              </div>
            </div>
            <div className="input-group">
              <input
                required
                type="text"
                placeholder="+92 Phone Number"
                className="input-field"
              />
              <input
                required
                type="text"
                placeholder="Company"
                className="input-field"
              />
            </div>
            <div className="payment-info">
              <h4>Payment Information</h4>
              <input
                required
                type="text"
                placeholder="Card Number"
                className="input-field"
              />
              <input
                required
                type="text"
                placeholder="MM/YY CVC"
                className="input-field"
              />
            </div>
            <FormControl fullWidth>
              <InputLabel>Select Plan</InputLabel>
              <Select
                value={selectedPlan}
                onChange={(e) => setSelectedPlan(e.target.value)}
              >
                <MenuItem value="All Source">All Source - $2200</MenuItem>
                <MenuItem value="Hospitality Source">
                  Hospitality Source - $580
                </MenuItem>
                <MenuItem value="Warehouse & Logistic Source">
                  Warehouse & Logistic Source - $450
                </MenuItem>
                <MenuItem value="Healthcare Source">
                  Healthcare Source - $360
                </MenuItem>
                <MenuItem value="Office Source">Office Source - $660</MenuItem>
              </Select>
            </FormControl>
            <button type="submit" className="large-button-contained">
              Register
            </button>
          </form>
          <p className="text-center mt-2">
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
